<template>
    <div>
        <sav-responsive-access-template logo="@/companies/marketmaker/assets/logo.png">
            <div class="w-full pt-4 bg-black">
                <img src="https://disticloudfiles.net/img/savinfo/logo/marketmaker.png" class="mx-auto h-14">
            </div>
            <svg style="margin-top: -1px" class="mb-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920.07 64">
                <polygon class="b" points=".03 .5 960.03 63.5 1920.03 .5 .03 .5" />
            </svg>
            <div class="container mx-auto mt-4">
                <div class="mb-4">
                    <div class="px-4">
                        <!-- Header -->
                        <div class="items-center justify-between md:flex">
                            <div>
                                <h1 class="mb-1 text-xl font-medium">
                                    <i class="mr-2 fas fa-store"></i>{{$t('template.header.espace_apres_vente')}}
                                </h1>
                                <p class="mb-0 text-xs font-light text-gray-500">{{$t('template.header.gerer_vos_retours_produit_et_votre_service_apres_vente')}}</p>
                            </div>
                            <div class="mt-2 hide-on-desktop"></div>
                            <div class="flex items-center gap-4">
                                <div v-if="$companyTool.confFile().translates" class="flex items-center gap-2">
                                    <div @click="changeLangage(lang.lang)" v-for="(lang, langIndex) in langs" :key="'menu-lang-' + langIndex" style="text-decoration: none">
                                        <img class="h-[15px] cursor-pointer hover:opacity-50 duration-200" :src="lang.logo" />
                                    </div>
                                </div>
                                <div v-if="user" class="flex items-center">
                                    <dropdown-menu class="rounded-xl" :overlay="false" :transition="null" :direction="screenWidth >= 992 ? 'right' : 'left'">
                                        <button slot="trigger" id="dropdownUser" class="bg-gray-200 hover:bg-gray-300 focus:outline-none font-medium rounded-lg text-sm px-3 py-2.5" type="button">
                                            <i class="mr-1 fas fa-bars"></i> {{$t('template.header.menu')}}
                                        </button>
                                        <div slot="body" class="bg-white divide-y divide-gray-100">
                                            <ul class="px-0 py-0 my-0 text-sm text-gray-700" aria-labelledby="dropdownUser">
                                                <li class="px-3 py-2 font-bold border-b border-gray-200 bg-gray-50">
                                                    <i class="mr-1 fas fa-home"></i> {{$t('template.header.accueil')}}
                                                </li>
                                                <a :href="$router.resolve({ name: 'home'}).href" style="text-decoration: none">
                                                    <li class="px-3 py-2 text-gray-500 cursor-pointer hover:text-gray-700"> {{$t('template.header.accueil')}} </li>
                                                </a>
                                                <li class="px-3 py-2 font-bold border-gray-200 bg-gray-50 border-y">
                                                    <i class="mr-1 fas fa-folder"></i> {{$t('template.header.mes_produits')}}
                                                </li>
                                                <a :href="$router.resolve({name: 'user.product.list'}).href" style="text-decoration: none">
                                                    <li class="px-3 py-2 text-gray-500 cursor-pointer hover:text-gray-700"> {{$t('template.header.mes_produits')}} </li>
                                                </a>
                                                <li class="px-3 py-2 font-bold border-gray-200 bg-gray-50 border-y">
                                                    <i class="mr-1 fas fa-user"></i> {{user.prenom + ' ' + user.nom}}
                                                </li>
                                                <a :href="$router.resolve({ name: 'user.update'}).href" style="text-decoration: none">
                                                    <li class="px-3 py-2 text-gray-500 cursor-pointer hover:text-gray-700"> {{$t('template.header.parametres')}} </li>
                                                </a>
                                                <a :href="$router.resolve({ name: 'user.logout'}).href" style="text-decoration: none">
                                                    <li class="px-3 py-2 text-gray-500 cursor-pointer hover:text-gray-700"> {{$t('template.header.se_deconnecter')}} </li>
                                                </a>
                                            </ul>
                                        </div>
                                    </dropdown-menu>
                                    <router-link :to="{ name: 'form.home'}" style="text-decoration: none">
                                        <button type="button" class="ml-2 text-white bg-black hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-3 py-2.5">
                                            <i class="mr-2 fas fa-plus"></i>{{formAlreadyExists ? 'Continuer la demande' : 'Nouvelle demande'}}
                                        </button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <hr class="mt-3 mb-4">
                        <!-- Page content -->
                        <div class="grid grid-cols-6 gap-10">
                            <div class="hidden py-2 lg:block lg:col-span-2">
                                <div class="sticky top-2">
                                    <img class="top-0 rounded-xl" :src="getLeftImg" alt="">
                                </div>
                            </div>
                            <div class="col-span-12 pt-0 lg:col-span-4" :class="!getLeftImg ? 'lg:col-start-2' : ''">
                                <h1 v-if="getTitle" :class="getTitle.class" class="text-3xl font-bold" style="color: #B18857">
                                    <i v-show="getTitle.icon" :class="getTitle.icon"></i>
                                    <span :class="getTitle.labelClass">{{title}}</span>
                                </h1>
                                <div class="w-full">
                                    <slot></slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="h-[80px]"></div>
            <div class="fixed bottom-0 left-0 right-0">
                <div class="container mx-auto py-2 pb-20 md:pb-2 text-[8px] md:text-xs text-center md:text-left font-light text-slate-600 grid md:grid-cols-2 md:gap-4">
                    <div>
                        <div v-if="$companyTool.confFile().num_rcs">Numéro RCS: {{ $companyTool.confFile().num_rcs }}</div>
                        <div v-if="$companyTool.confFile().num_tva">TVA Intracommunautaire: {{ $companyTool.confFile().num_tva }}</div>
                    </div>
                    <div class="md:text-right">
                        <div v-if="$companyTool.confFile().url_politique"><a :href="$companyTool.confFile().url_politique" target="_blank" class="underline">Accéder à la politique de confidentialité</a></div>
                        <div>Plateforme développée et maintenue par <a href="https://districloud.fr" target="_blank" class="underline">https://districloud.fr</a></div>
                    </div>
                </div>
            </div>

            <!-- Cookies -->
            <modal name="sav-setting-cookie">
                <div>
                    <div class="mb-4 pb-4 border-b flex items-center justify-between text-2xl">
                        <h1 class="font-bold" :class="'text-[' + $companyTool.confFile().style.css.defaultBgColor + ']'">Configurer les cookies</h1>
                        <button @click="$modal.hide('sav-setting-cookie')">
                            <i class="fas fa-times text-red-500"></i>
                        </button>
                    </div>
                    <div class="font-bold text-xl">Cookies strictement nécessaires :</div>
                    <div>Ces cookies sont strictement nécessaires au fonctionnement du site Web et ne peuvent pas être désactivés dans nos systèmes. Ils sont généralement établis en tant que réponse à des actions que vous avez effectuées et qui constituent une demande de services comme : la définition de vos préférences en matière de confidentialité, la connexion ou le remplissage de formulaires, etc Vous pouvez configurer votre navigateur afin de bloquer certains cookies comme détaillé dans la partie « Comment gérer mes cookies ?» de notre Politique de cookies.</div>
                    <div class="border-t mt-4"></div>
                    <div class="mt-4 flex">
                        <input v-model="acceptCookieFonctionnalite" type="checkbox" class="focus:outline-none mt-1.5 mr-5" />
                        <div>
                            <b>Cookies de performance</b> : ces cookies nous permettent de déterminer le nombre de visites et les sources du trafic afin de mesure et d’améliorer les performances de notre site Web. Si vous n’acceptez pas ces cookies, nous ne serons pas informés de votre visite sur notre site.
                        </div>
                    </div>
                    <div class="mt-4 flex items-start">
                        <button @click="$toast.warning('Ces cookies sont obligatoires')" class="mt-1.5 mr-5" style="font-size: 18px"><i class="fa-solid fa-square-check text-blue-600"></i></button>
                        <div>
                            <b>Cookies de fonctionnalité</b> : ces cookies permettent d’améliorer et de personnaliser les fonctionnalités des site web. Si vous n’acceptez pas ces cookies, une partie ou la totalité des services risquent de ne pas fonctionner correctement ou de vous être inaccessibles.
                        </div>
                    </div>
                    <div class="border-t mt-4"></div>
                    <div class="mt-4 text-xs font-light">En renseignant les données personnelles demandez, vous consentez à ce que ces données soient collectées et traitées selon les dispositions de notre <a href="https://disticloudfiles.net/upload/files/Politique%20de%20confidentialite%20-%20SAVLOG.pdf" class="underline" target="_blank">Politique de confidentialité</a> et les réglementations en vigueur</div>
                    <div class="border-t mt-4"></div>
                    <button @click="setRgpdCookie({perf: 0, fonctionnalite: acceptCookieFonctionnalite ? 1 : 0})" class="px-4 py-2 rounded mt-4 text-white" :class="'bg-[' + $companyTool.confFile().style.css.defaultBgColor + ']'"><i class="fas fa-check mr-2"></i> Valider</button>
                </div>
            </modal>
            <div v-if="displayCookie" class="fixed bottom-5 left-5 p-4 rounded bg-slate-50 shadow-lg shadow-slate-400 border w-[500px]">
                <div class="flex items-center gap-2">
                    <img class="h-[30px]" src="https://cdn-icons-png.flaticon.com/512/1047/1047711.png" alt="">
                    <div class="text-lg font-bold">Politique des cookies</div>
                </div>
                <div class="text-xs mt-2">
                    Avec votre consentement nous utilisons des cookies internes et tiers pour faciliter votre expérience avec nos services et analyser notre trafic. Nous partageons également des informations, quant à votre navigation sur notre site, avec nos partenaires analytiques et de réseaux sociaux. Vous pouvez gérer ou retirer votre consentement à tout moment. Nous conservons votre choix pendant la période légale maximum c’est à dire 13 mois. Vous pouvez paramétrer les cookies en cliquant sur le bouton ci-dessous. Pour plus d’informations sur l’utilisation des cookies, vous pouvez consulter la <a href="https://disticloudfiles.net/upload/files/Politique%20de%20cookies%20-%20SAV.pdf" class="underline" target="_blank">politique des cookies</a>
                </div>
                <div class="grid grid-cols-2 gap-4 mt-2">
                    <button @click="setRgpdCookie({perf: 0, fonctionnalite: 1})" class="px-2 py-1.5 rounded bg-slate-300">Je refuse</button>
                    <button @click="setRgpdCookie({perf: 1, fonctionnalite: 1})" class="px-2 py-1.5 rounded text-white" :class="'bg-[' + $companyTool.confFile().style.css.defaultBgColor + ']'">J'accepte</button>
                </div>
                <div @click="$modal.show('sav-setting-cookie')" class="text-xs font-light mt-2 cursor-pointer hover:underline"><i class="fas fa-cog mr-1"></i> Paramétrer les cookies</div>
            </div>
        </sav-responsive-access-template>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

import SavResponsiveAccessTemplate from '../../../../components/SavResponsiveAccessTemplate.vue'

export default {
    props: {
        title: {
            type: String,
            default: "Marketmaker"
        },
        backButton: {
            type: Boolean,
            default: true
        },
        navigationBar: {
            type: Boolean,
            default: true
        }
    },
    components: {
        SavResponsiveAccessTemplate
    },
    data() {
        return {
            screenWidth: 0,
            user: null,
            langage: 'fr',
            langs: [],
            displayCookie: false,
            acceptCookieFonctionnalite: true,
        }
    },
    computed: {
        getLeftImg() {
            let routesWithoutImages = [
                'user.login',
                'user.login.actors',
                'user.logout',
                'user.password-forgot',
                'user.password-token'
            ]
            if (routesWithoutImages.find((el) => el === this.$route.name)) {
                return null
            }

            let routesimages = [
                {name: 'home', url: require('./../../assets/tv1.jpg')},
                {name: 'user.product.list', url: require('./../../assets/tv3.jpg')},
                {name: 'user.update', url: require('./../../assets/tv4.jpg')},
            ]
            let getimage = routesimages.find((el) => el.name === this.$route.name)
            return getimage ? getimage.url : require('./../../assets/tv2.jpg')
        },
        displayInsideContainer() {
            let containerRoutes = [
                'form.home'
            ]
            return containerRoutes.find((el) => el === this.$route.name) ? true : false
        },
        getTitle() {
            let routeWithTitle = [
                {name: 'form.home', labelClass: 'ml-2'},
                {name: 'form.warranty-identification'},
                {name: 'user.product.list', class: 'mb-3', labelClass: 'ml-2', class: 'mb-3', icon: 'fas fa-tag'},
                {name: 'user.folder.list', labelClass: 'ml-2', class: 'mb-3', icon: 'fas fa-folder'},
            ]
            return routeWithTitle.find((el) => el.name === this.$route.name)
        },
        formAlreadyExists() {
            return localStorage['form-data'] ? true : false
        },
        cantDisplayOnMobile() {
            if (this.screenWidth <= 650 && !this.$companyTool.confFile().mobile) {
                return true
            }
            return false
        }
    },
    methods: {
        isSelect(routeName) {
            return (
                this.$route.name.split('.')[0] == routeName
                || this.$route.name == routeName
            ) ? true : false
        },
        changeLangage(lang) {
            localStorage.setItem('langage', lang)
            location.reload()
        },
        async getAllLang() {
            let response = await apiService.post('getalllang', {})
            this.langs = response.data.posts.post
        },

        setRgpdCookie(data) {
            let now = new Date();
            let expiryDate = new Date();
            expiryDate.setMonth(now.getMonth() + 13);
            data.expiry = expiryDate.getTime()
            localStorage.setItem('accept-cookie', JSON.stringify(data))
            this.displayCookie = false
        }
    },

    async mounted() {
        let userStorage = localStorage.getItem('user-session')
        userStorage = userStorage ? JSON.parse(userStorage) : null

        const d = new Date();
        let currentTime = d.getTime();

        if (userStorage && userStorage.user && (currentTime - userStorage.time) < 600000) {
            this.user = userStorage.user
        } else {
            this.user = await apiService.getUser()
            localStorage.setItem('user-session', JSON.stringify({
                user: await apiService.getUser(),
                time: currentTime
            }))
        }

        document.title = "Market Maker - Espace après-vente"
        document.body.style.backgroundColor = "#fff";
        document.body.style.color = "#000";

        this.screenWidth = window.innerWidth
        window.addEventListener('resize', (event) => {
            this.screenWidth = window.innerWidth
        }, true);

        // Colors
        var style = document.createElement("style")
        style.textContent = `
            .default-bg-color {background: #B18857 !important;}
            .default-text-color {color: #B18857 !important;}
            .default-bg-color-hover:hover {background: #000 !important;}
            .default-text-inside-color {color: #fff !important;}
        `
        document.head.appendChild(style)

        // Lang
        await this.getAllLang()
        const lang = await this.$companyTool.getLang()
        this.langage = lang

        // Cookies
        if (localStorage.getItem('accept-cookie') == null) {
            this.displayCookie = true
        } else {
            let rgpd = JSON.parse(localStorage.getItem('accept-cookie'))
            let now = new Date();
            if (now.getTime() > rgpd.expiry) {
                localStorage.removeItem('accept-cookie');
                this.displayCookie = true
            }
        }
    },
}
</script>

<style>
.navigation {
    border-left: 5px solid white !important;
}
.navigation:hover {
    font-weight: 300 !important;
    color: black !important;
    background: rgb(248, 249, 250);
}

.navigation:hover .separator {
    background: black !important;
}
</style>



// WEBPACK FOOTER //
// src/companies/marketmaker/views/template/SavTemplate.vue